import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { theme } from './theme.ts';

import Navbar from './components/Navbar/Navbar.tsx';
import Hero from './components/Hero/Hero.tsx';
import Products from './components/Products/Products.tsx';
import BulkOrders from './components/BulkOrders/BulkOrders.tsx';
import About from './components/About/About.tsx';
import Contact from './components/Contact/Contact.tsx';
import Footer from './components/Footer/Footer.tsx';
import WhatsAppButton from './components/WhatsApp/WhatsAppButton.tsx';
import './App.css';
import './styles/custom.css';
import { CategoryProvider } from './context/CategoryContext.tsx';

const HomePage = () => (
  <>
    <Navbar />
    <Hero />
    <BulkOrders />
    <Products />
    <About />
    <Footer />
  </>
);

const ContactPage = () => (
  <>
    <Navbar />
    <Contact />
    <Footer />
  </>
);

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <CategoryProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/contact" element={<ContactPage />} />
            </Routes>
            <WhatsAppButton />
          </div>
        </Router>
      </CategoryProvider>
    </ThemeProvider>
  );
}

export default App;